module.exports = __webpack_public_path__ + "static/media/close-circle-cr.d9b58f02.svg";